;(function () {
    if (!document.documentElement.lang || !document.documentElement.lang.startsWith('sv')) return

    const selectors = [
        'option',
        '.subscription-details',
        'td.subscription-total',
        '.woocommerce-orders-table__cell-subscription-total',
        '.woocommerce-orders-table__cell-order-total',
        '.wcsatt-options-product-dropdown option',
        '.subscription-details',
        '.one-time-option-details',
        '.woocommerce-Price-amount.amount',
        '.recurring-total',
    ].join(',')

    function fixText(text) {
        if (!text) return text

        let t = text.replace(/\s+/g, ' ').trim()

        t = t.replace(/en\s+gång/gi, 'En gång')

        t = t.replace(/varje\s+1\s+månad/gi, 'Varje månad')
        t = t.replace(/varje\s+månad/gi, 'Varje månad')
        t = t.replace(/varje\s+2\s+månader?/gi, 'Varannan månad')
        t = t.replace(/varje\s+(\d+)\s+månader?/gi, (m, n) => `Var ${n}:e månad`)

        t = t.replace(/varje\s+1\s+veckor?/gi, 'Varje vecka')
        t = t.replace(/varje\s+vecka/gi, 'Varje vecka')
        t = t.replace(/varje\s+2\s+veckor?/gi, 'Varannan vecka')
        t = t.replace(/varje\s+(\d+)\s+veckor?/gi, (m, n) => `Var ${n}:e vecka`)

        return t
    }

    function processElement(el) {
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false)
        let node
        while ((node = walker.nextNode())) {
            const original = node.nodeValue
            if (!original) continue

            const trimmed = original.trim()
            if (!/(varje|Varje|en gång|En gång)/.test(trimmed)) continue

            const fixed = fixText(trimmed)
            if (fixed === trimmed) continue

            const leading = original.match(/^\s*/)[0]
            const trailing = original.match(/\s*$/)[0]

            node.nodeValue = leading + fixed + trailing
        }
    }

    function scan() {
        document.querySelectorAll(selectors).forEach(processElement)
    }

    scan()

    const obs = new MutationObserver(scan)
    obs.observe(document.body, { childList: true, subtree: true })
})()
